// extracted by mini-css-extract-plugin
export default {"input":"yea-z","button":"zea-z","selected":"Aea-z","unavailable":"Bea-z","oos":"Cea-z","image":"Dea-z","paperCutDisabledOverlay":"Eea-z"};